import * as React from 'react';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

const Pagination: React.FunctionComponent<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  className = ''
}: PaginationProps): JSX.Element | null => {
  
  if (totalPages <= 1) {
    return null;
  }

  const movePage = (direction: number) => {
    const newPage = currentPage + direction;
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const getPageNumbers = (): (number | string)[] => {
    if (totalPages <= 4) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    
    const pageNumbers: (number | string)[] = [];
    
    pageNumbers.push(1);
    
    if (currentPage <= 3) {
      pageNumbers.push(2, 3, '...', totalPages);
    } else if (currentPage >= totalPages - 2) {
      pageNumbers.push('...', totalPages - 2, totalPages - 1, totalPages);
    } else {
      pageNumbers.push('...', currentPage, '...', totalPages);
    }
    
    return pageNumbers;
  };

  const pageNumbers = getPageNumbers();
  
  return (
    <div className={`uber-table-pagination ${className}`}>
      <nav aria-label="Table Pagination">
        <ul className="pagination">
          <li 
            className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
            onClick={() => movePage(-1)}
          >
            <a className="custom-arrow btn-primary custom-arrow-prev" type="button" aria-label="prev">
              <i className="fa fa-chevron-left"></i>
            </a>
          </li>

          {pageNumbers.map((pageNum, index) => {
            if (pageNum === '...') {
              return (
                <li className="page-item disabled" key={`ellipsis${index}`}>
                  <span className="page-link">...</span>
                </li>
              );
            }
            
            return (
              <li
                className={`page-item numbers ${currentPage === pageNum ? "active" : ""}`}
                key={`page${pageNum}`}
              >
                <div
                  className="page-link"
                  onClick={() => {
                    onPageChange(pageNum as number);
                  }}
                >
                  {pageNum}
                </div>
              </li>
            );
          })}

          <li 
            className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}
            onClick={() => movePage(1)}
          >
            <a className="custom-arrow btn-primary custom-arrow-next" type="button" aria-label="next">
              <i className="fa fa-chevron-right"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;